export default "__VITE_ASSET__BVkTcrqi__"